import React from 'react';
import { ContainerComponent, wrap } from 'AppReact';
import { Icon, SecondaryTextXs, SecondaryTextSm } from 'atoms';
import { StaticWrapper, FlexCenterWrapper, WhiteSpaceNoWrap, Mx2, FlexCenterBetweenWrapper } from 'wrappers';
import Controller from './controller';
import { BodyWrapper, DatesWrapper, HeaderWrapper } from './wrappers';
import internalState from './internalState';
import { DownCaretSvg } from 'components/icons';
import labelSwitch from './labelSwitch';
import { textEllipsis } from 'utils/ellipsis';
import { DayText } from './atoms';
import { months } from './utils';
import { LeftArrowSvg, RightArrowSvg } from 'components/icons';

const containerRef = React.createRef();

export const definition = {
  name: 'Dropdown',
  controller: Controller,
  initialProps: ({ selectedDates, label, annually }) => ({ selectedDates, label, annually }),
  props: internalState,
  elements: [
    {
      wrapper: HeaderWrapper,
      name: 'Selector',
      isButton: true,
      bindings: ({ isOpen }) => ({ isOpen, containerRef }),
      elements: [
        {
          wrapper: FlexCenterWrapper,
          name: 'LeftSide',
          elements: [
            {
              componentSelect: labelSwitch,
              name: 'Label',
              displayValue: ({ label }) => label.values[0],
              renderIf: ({ label }) => !!label?.component,
              bindings: ({ label }) => {
                if (label.keys?.length > 0) {
                  const combinedValues = { ...label };
                  label.keys.forEach((key, index) => {
                    combinedValues[key] = label.values[index];
                  });
                  return combinedValues;
                }
                return label;
              }
            },
            {
              component: wrap(wrap(SecondaryTextXs, WhiteSpaceNoWrap), Mx2),
              name: 'SelectedValue',
              displayValue: ({ selectedDates }) => {
                return textEllipsis(selectedDates.join(', '), 15)
              }
            }
          ]
        },
        {
          component: Icon,
          name: 'DownCaretSvg',
          displayValue: () => DownCaretSvg({}),
          bindings: () => ({})
        }
      ]
    },
    {
      wrapper: BodyWrapper,
      name: 'Body',
      ref: containerRef,
      renderIf: ({ isOpen }) => isOpen,
      elements: [
        {
          wrapper: FlexCenterBetweenWrapper,
          name: 'MonthSelector',
          renderIf: ({ annually }) => annually,
          elements: [
            {
              component: SecondaryTextSm,
              name: 'Month',
              displayValue: ({ selectedMonthIndex }) => months.find(month => month.index === selectedMonthIndex).name,
            },
            {
              wrapper: FlexCenterWrapper,
              name: 'Buttons',
              elements: [
                {
                  wrapper: Mx2,
                  name: 'PrevMonth',
                  isButton: true,
                  bindings: ({ selectedMonthIndex }) => ({ selectedMonthIndex }),
                  elements: [
                    {
                      component: Icon,
                      name: 'Icon',
                      displayValue: ({ }) => LeftArrowSvg({})
                    },
                  ]
                },
                {
                  wrapper: Mx2,
                  name: 'NextMonth',
                  isButton: true,
                  bindings: ({ selectedMonthIndex }) => ({ selectedMonthIndex }),
                  elements: [
                    {
                      component: Icon,
                      name: 'Icon',
                      displayValue: ({ }) => RightArrowSvg({})
                    },
                  ]
                }
              ]
            }
          ]
        },
        {
          wrapper: DatesWrapper,
          name: 'Dates',
          elements: [
            {
              component: DayText,
              name: 'Day',
              isListOf: 'dates',
              displayValue: ({ date }) => date.toString(),
              displayState: ({ date, selectedDates, selectedMonthIndex, annually }) => ({ selected: annually ? selectedDates.includes(`${selectedMonthIndex}/${date}`) : selectedDates.includes(date.toString()) }),
              bindings: ({ date, selectedDates, annually, selectedMonthIndex }) => ({ date, selectedDates, annually, selectedMonthIndex })
            }
          ]
        }
      ]
    }
  ]
};

const Dropdown = ContainerComponent(definition);

export default wrap(Dropdown, StaticWrapper);
